/**
 * Heritage Parts Co. — Part Identifier
 * Posts multipart case to NetSuite external form.
 */
(function () {
  'use strict';

  var $j = window.jQuery;
  var formLoadTime = Date.now();

  window.PI_RECAPTCHA_CONFIG = {
    enabled: false,
    debug: false,
    siteKey: '6LdZTtosAAAAAJm5j8OkM3Kss0P7t6OlKqwwYADM',
    useEnterprise: true,
    recaptchaAction: 'part_identifier',
    verifySuiteletUrl:
      'https://4118934.extforms.netsuite.com/app/site/hosting/scriptlet.nl?script=1453&deploy=1&compid=4118934&ns-at=AAEJ7tMQ4uw3K1SEYcn5TJuyryODZsBt-oAehGxt2fUDuoUSw0U'
  };

  function sanitizeText(input) {
    if (typeof input !== 'string') return '';
    return input
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#x27;')
      .trim();
  }

  function sanitizeFileName(fileName) {
    if (typeof fileName !== 'string') return 'unknown_file';
    return fileName
      .replace(/[<>:"/\\|?*]/g, '_')
      .replace(/\.\./g, '_')
      .replace(/^\./, '_')
      .substring(0, 100)
      .trim();
  }

  function createSafeTextNode(text) {
    return document.createTextNode(sanitizeText(text));
  }

  function isHeicFile(file) {
    if (!file) return false;
    var name = String(file.name || '').toLowerCase();
    var type = String(file.type || '').toLowerCase();
    return /\.(heic|heif)$/.test(name) || type === 'image/heic' || type === 'image/heif';
  }

  function validateFileType(file) {
    var allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
    var allowedExtensions = ['.jpg', '.jpeg', '.png'];
    if (!allowedTypes.includes(file.type)) return false;
    var fileName = file.name.toLowerCase();
    if (!allowedExtensions.some(function (ext) { return fileName.endsWith(ext); })) return false;
    if (file.size > 10 * 1024 * 1024) return false;
    return true;
  }

  function compressImage(file, maxWidth, maxHeight, quality) {
    maxWidth = maxWidth || 1200;
    maxHeight = maxHeight || 900;
    quality = quality || 0.75;
    return new Promise(function (resolve) {
      var canvas = document.createElement('canvas');
      var ctx = canvas.getContext('2d');
      var img = new Image();
      var objectUrl = URL.createObjectURL(file);
      function useOriginal() {
        URL.revokeObjectURL(objectUrl);
        resolve(file);
      }
      img.onload = function () {
        try {
          if (!ctx) return useOriginal();
          var width = img.width;
          var height = img.height;
          if (width > height) {
            if (width > maxWidth) {
              height = (height * maxWidth) / width;
              width = maxWidth;
            }
          } else if (height > maxHeight) {
            width = (width * maxHeight) / height;
            height = maxHeight;
          }
          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(img, 0, 0, width, height);
          canvas.toBlob(function (blob) {
            if (blob) {
              URL.revokeObjectURL(objectUrl);
              resolve(blob);
            } else useOriginal();
          }, 'image/jpeg', quality);
        } catch (e) {
          useOriginal();
        }
      };
      img.onerror = useOriginal;
      img.src = objectUrl;
    });
  }

  function updateIncomingMessage() {
    var partSubject = sanitizeText((document.getElementById('part_subject') || {}).value || '');
    var partMessage = sanitizeText((document.getElementById('part_message') || {}).value || '');
    var imageCount = 0;
    for (var i = 1; i <= 4; i++) {
      var fileInput = document.getElementById('file' + i);
      if (fileInput && fileInput.files && fileInput.files.length) imageCount++;
    }
    var videoInput = document.getElementById('video1');
    var hasVideo = !!(videoInput && videoInput.files && videoInput.files.length);
    var details = ['PART IDENTIFICATION REQUEST', '===========================', ''];
    if (partSubject) details.push('Subject: ' + partSubject);
    if (partMessage) {
      details.push('');
      details.push('MESSAGE:');
      details.push(partMessage);
    }
    if (imageCount) {
      details.push('');
      details.push('Photos Uploaded: ' + imageCount);
    }
    if (hasVideo) {
      details.push('');
      details.push('Video Uploaded: Yes');
    }
    details.push('');
    details.push('Generated by Heritage Parts Co. Part Identifier');
    var messageField = document.getElementById('incomingmessage');
    if (messageField) messageField.value = details.join('\n');
  }

  function renameUploadedFiles() {
    var firstName = ((document.getElementById('firstname') || {}).value || '').trim() || 'customer';
    var lastName = ((document.getElementById('lastname') || {}).value || '').trim() || 'part';
    if (firstName === 'customer' && lastName === 'part') return;
    var namePattern = /^[^_]+_[^_]+_PI_\d{6}(_\d{4})?\./;
    for (var i = 1; i <= 4; i++) {
      var fileInput = document.getElementById('file' + i);
      if (!fileInput || !fileInput.files || !fileInput.files.length) continue;
      var currentFile = fileInput.files[0];
      var currentName = currentFile.name;
      if (!namePattern.test(currentName)) continue;
      var parts = currentName.split('_');
      var piIndex = parts.indexOf('PI');
      var timestampWithExt = parts.slice(piIndex + 1).join('_');
      var timestamp = timestampWithExt.split('.')[0];
      var extension = currentName.split('.').pop() || 'jpg';
      var newFileName = firstName + '_' + lastName + '_PI_' + timestamp + '.' + extension;
      if (newFileName === currentName || typeof DataTransfer !== 'function') continue;
      var renamedFile = new File([currentFile], newFileName, {
        type: currentFile.type,
        lastModified: currentFile.lastModified
      });
      var dt = new DataTransfer();
      dt.items.add(renamedFile);
      fileInput.files = dt.files;
      var fileNameDiv = document.getElementById('file-name-' + i);
      if (fileNameDiv) {
        fileNameDiv.textContent = 'Selected: ' + sanitizeFileName(newFileName);
        fileNameDiv.classList.add('is-ok');
      }
    }
  }

  window.updateSingleImage = function (input, containerNum) {
    var fileNameDiv = document.getElementById('file-name-' + containerNum);
    var imagePreview = document.getElementById('image-preview-' + containerNum);
    var uploadContent = document.getElementById('upload-content-' + containerNum);
    var imageContainer = document.getElementById('image-container-' + containerNum);
    if (!fileNameDiv || !imagePreview || !uploadContent || !imageContainer) return;

    while (imageContainer.firstChild) imageContainer.removeChild(imageContainer.firstChild);
    fileNameDiv.textContent = '';
    fileNameDiv.classList.remove('is-ok', 'is-error');

    if (!(input.files && input.files.length)) {
      uploadContent.style.display = 'flex';
      imagePreview.classList.remove('is-visible');
      return;
    }

    var file = input.files[0];
    if (isHeicFile(file)) {
      fileNameDiv.textContent = 'Unsupported iPhone photo. Please upload JPG or PNG.';
      fileNameDiv.classList.add('is-error');
      input.value = '';
      return;
    }
    if (!validateFileType(file)) {
      fileNameDiv.textContent = 'Invalid file or too large (max 10MB). JPG/PNG only.';
      fileNameDiv.classList.add('is-error');
      input.value = '';
      return;
    }

    fileNameDiv.textContent = 'Compressing…';
    compressImage(file).then(function (compressedBlob) {
      var firstName = ((document.getElementById('firstname') || {}).value || 'customer').trim() || 'customer';
      var lastName = ((document.getElementById('lastname') || {}).value || 'part').trim() || 'part';
      var now = new Date();
      var timestamp =
        String(now.getMonth() + 1).padStart(2, '0') +
        String(now.getDate()).padStart(2, '0') +
        String(now.getFullYear()).slice(-2) +
        '_' +
        String(now.getMinutes()).padStart(2, '0') +
        String(now.getSeconds()).padStart(2, '0');
      var outputType = compressedBlob.type === 'image/png' ? 'image/png' : 'image/jpeg';
      var outputExtension = outputType === 'image/png' ? 'png' : 'jpg';
      var newFileName = firstName + '_' + lastName + '_PI_' + timestamp + '.' + outputExtension;
      var submittedFile = file;
      var submittedFileName = file.name;
      try {
        if (typeof File === 'function' && typeof DataTransfer === 'function') {
          var compressedFile = new File([compressedBlob], newFileName, {
            type: outputType,
            lastModified: Date.now()
          });
          var dt = new DataTransfer();
          dt.items.add(compressedFile);
          input.files = dt.files;
          submittedFile = compressedFile;
          submittedFileName = newFileName;
        }
      } catch (e) { /* keep original */ }

      fileNameDiv.textContent =
        'Selected: ' +
        sanitizeFileName(submittedFileName) +
        ' (' +
        (submittedFile.size / 1024 / 1024).toFixed(2) +
        'MB)';
      fileNameDiv.classList.add('is-ok');

      var reader = new FileReader();
      reader.onload = function (e) {
        var img = document.createElement('img');
        img.src = e.target.result;
        img.alt = 'Preview ' + containerNum;
        var removeBtn = document.createElement('button');
        removeBtn.type = 'button';
        removeBtn.className = 'phk-pi__remove';
        removeBtn.setAttribute('aria-label', 'Remove photo');
        removeBtn.appendChild(createSafeTextNode('×'));
        removeBtn.addEventListener('click', function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
          window.clearSingleImage(containerNum);
        });
        imageContainer.appendChild(img);
        imageContainer.appendChild(removeBtn);
        uploadContent.style.display = 'none';
        imagePreview.classList.add('is-visible');
      };
      reader.readAsDataURL(compressedBlob);
    });
  };

  window.clearSingleImage = function (containerNum) {
    var fileInput = document.getElementById('file' + containerNum);
    var fileNameDiv = document.getElementById('file-name-' + containerNum);
    var imagePreview = document.getElementById('image-preview-' + containerNum);
    var uploadContent = document.getElementById('upload-content-' + containerNum);
    var imageContainer = document.getElementById('image-container-' + containerNum);
    if (fileInput) fileInput.value = '';
    if (fileNameDiv) {
      fileNameDiv.textContent = '';
      fileNameDiv.classList.remove('is-ok', 'is-error');
    }
    if (imageContainer) while (imageContainer.firstChild) imageContainer.removeChild(imageContainer.firstChild);
    if (imagePreview) imagePreview.classList.remove('is-visible');
    if (uploadContent) uploadContent.style.display = 'flex';
  };

  function revokeVideoPreviewUrl(videoContainer) {
    if (!videoContainer) return;
    var existingVideo = videoContainer.querySelector('video[data-object-url]');
    if (existingVideo && existingVideo.dataset.objectUrl) {
      URL.revokeObjectURL(existingVideo.dataset.objectUrl);
    }
  }

  window.updateSingleVideo = function (input, containerNum) {
    var fileNameDiv = document.getElementById('video-name-' + containerNum);
    var videoPreview = document.getElementById('video-preview-' + containerNum);
    var uploadContent = document.getElementById('upload-content-video' + containerNum);
    var videoContainer = document.getElementById('video-container-' + containerNum);
    if (!fileNameDiv || !videoPreview || !uploadContent || !videoContainer) return;
    revokeVideoPreviewUrl(videoContainer);
    while (videoContainer.firstChild) videoContainer.removeChild(videoContainer.firstChild);
    fileNameDiv.textContent = '';
    fileNameDiv.classList.remove('is-ok', 'is-error');

    if (!(input.files && input.files.length)) {
      uploadContent.style.display = 'flex';
      videoPreview.classList.remove('is-visible');
      return;
    }

    var file = input.files[0];
    if (!file.type.startsWith('video/')) {
      fileNameDiv.textContent = 'Please select a video file.';
      fileNameDiv.classList.add('is-error');
      input.value = '';
      return;
    }
    if (file.size > 8 * 1024 * 1024) {
      fileNameDiv.textContent = 'Video too large (max 8MB). Use a shorter clip.';
      fileNameDiv.classList.add('is-error');
      input.value = '';
      return;
    }

    fileNameDiv.textContent =
      'Selected: ' + sanitizeFileName(file.name) + ' (' + (file.size / 1024 / 1024).toFixed(2) + 'MB)';
    fileNameDiv.classList.add('is-ok');

    var video = document.createElement('video');
    var videoObjectUrl = URL.createObjectURL(file);
    video.src = videoObjectUrl;
    video.dataset.objectUrl = videoObjectUrl;
    video.controls = true;
    video.playsInline = true;
    var removeBtn = document.createElement('button');
    removeBtn.type = 'button';
    removeBtn.className = 'phk-pi__remove';
    removeBtn.setAttribute('aria-label', 'Remove video');
    removeBtn.appendChild(createSafeTextNode('×'));
    removeBtn.addEventListener('click', function (ev) {
      ev.preventDefault();
      ev.stopPropagation();
      window.clearSingleVideo(containerNum);
    });
    videoContainer.appendChild(video);
    videoContainer.appendChild(removeBtn);
    uploadContent.style.display = 'none';
    videoPreview.classList.add('is-visible');
  };

  window.clearSingleVideo = function (containerNum) {
    var fileInput = document.getElementById('video' + containerNum);
    var fileNameDiv = document.getElementById('video-name-' + containerNum);
    var videoPreview = document.getElementById('video-preview-' + containerNum);
    var uploadContent = document.getElementById('upload-content-video' + containerNum);
    var videoContainer = document.getElementById('video-container-' + containerNum);
    if (fileInput) fileInput.value = '';
    if (fileNameDiv) {
      fileNameDiv.textContent = '';
      fileNameDiv.classList.remove('is-ok', 'is-error');
    }
    revokeVideoPreviewUrl(videoContainer);
    if (videoContainer) while (videoContainer.firstChild) videoContainer.removeChild(videoContainer.firstChild);
    if (videoPreview) videoPreview.classList.remove('is-visible');
    if (uploadContent) uploadContent.style.display = 'flex';
  };

  window.clearAllImages = function () {
    for (var i = 1; i <= 4; i++) window.clearSingleImage(i);
    window.clearSingleVideo(1);
  };

  function resetSubmitButton(submitBtn) {
    submitBtn.prop('disabled', false).removeClass('is-loading phk-pi__submit is-loading');
    submitBtn.removeClass('loading');
    submitBtn.text('Submit Part Identifier Form');
  }

  function piRecaptchaThenSubmitNative(form, submitBtn) {
    var cfg = window.PI_RECAPTCHA_CONFIG;
    var hp = document.getElementById('pi_hp_url');
    if (hp && hp.value) return;
    if (Date.now() - formLoadTime < 3500) return;

    function scheduleReset() {
      setTimeout(function () {
        form.reset();
        if (typeof window.clearAllImages === 'function') window.clearAllImages();
        resetSubmitButton(submitBtn);
      }, 3000);
    }

    // reCAPTCHA disabled by default — same as source form until keys/suitelet are confirmed for this storefront
    if (!cfg || !cfg.enabled) {
      submitBtn.text('Submitting…').prop('disabled', true).addClass('is-loading');
      setTimeout(function () {
        form.submit();
        scheduleReset();
      }, 100);
      return;
    }

    alert('Security verification is not configured for this storefront yet. Please contact us.');
    resetSubmitButton(submitBtn);
  }

  function initPhotoAreas() {
    for (var i = 1; i <= 4; i++) {
      (function (n) {
        var area = document.getElementById('upload-area-' + n);
        var input = document.getElementById('file' + n);
        var content = document.getElementById('upload-content-' + n);
        if (!area || !input || !content || area.__phkBound) return;
        area.__phkBound = true;
        area.addEventListener('click', function (e) {
          if (e.target === area || e.target === content || content.contains(e.target)) input.click();
        });
        area.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            input.click();
          }
        });
        ['dragenter', 'dragover'].forEach(function (evt) {
          area.addEventListener(evt, function (e) {
            e.preventDefault();
            area.classList.add('is-dragover');
          });
        });
        ['dragleave', 'drop'].forEach(function (evt) {
          area.addEventListener(evt, function (e) {
            e.preventDefault();
            area.classList.remove('is-dragover');
          });
        });
        area.addEventListener('drop', function (e) {
          e.preventDefault();
          if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length) {
            input.files = e.dataTransfer.files;
            window.updateSingleImage(input, n);
          }
        });
      })(i);
    }

    var videoArea = document.getElementById('upload-area-video1');
    var videoInput = document.getElementById('video1');
    var videoContent = document.getElementById('upload-content-video1');
    if (videoArea && videoInput && videoContent && !videoArea.__phkBound) {
      videoArea.__phkBound = true;
      videoArea.addEventListener('click', function (e) {
        if (e.target === videoArea || e.target === videoContent || videoContent.contains(e.target)) {
          videoInput.click();
        }
      });
    }
  }

  function initializeForm() {
    if (typeof window.jQuery !== 'function') {
      console.error('[PHK Part Identifier] jQuery missing');
      return;
    }
    $j = window.jQuery;
    var form = document.getElementById('main_form');
    if (!form) return;
    if (form.__phkInitialized && $j(form).data('validator')) return;
    form.__phkInitialized = true;

    var messageField = document.getElementById('incomingmessage');
    if (messageField) messageField.value = 'Part identifier form initialized';
    updateIncomingMessage();
    initPhotoAreas();

    $j('#part_message, #part_subject, #firstname, #lastname, #email, #phone').on('input change', function () {
      clearTimeout(window.__phkMsgTimer);
      window.__phkMsgTimer = setTimeout(updateIncomingMessage, 250);
    });
    $j('#firstname, #lastname').on('input change', function () {
      renameUploadedFiles();
    });

    if (!($j.validator && typeof $j.fn.validate === 'function')) {
      console.warn('[PHK Part Identifier] jquery.validate missing — using native required');
      return;
    }

    $j.validator.addMethod(
      'tc_emailDomainCheck',
      function (value, element) {
        return (
          this.optional(element) ||
          /^(?:[a-zA-Z0-9!#$%&*+\/=?^_{|}~-]+(?:\.[a-zA-Z0-9!#$%&*+\/=?^_{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/.test(
            value
          )
        );
      },
      'Please enter a valid email address.'
    );

    $j.validator.addMethod(
      'tc_phoneUS',
      function (phone_number, element) {
        phone_number = phone_number.replace(/[\s.\-()+]/g, '');
        if (phone_number.length === 11 && phone_number.charAt(0) === '1') {
          phone_number = phone_number.substring(1);
        }
        return this.optional(element) || (phone_number.length === 10 && /^[2-9]\d{2}[2-9]\d{6}$/.test(phone_number));
      },
      'Please enter a valid US phone number (e.g. 555-867-5309)'
    );

    $j('#main_form').validate({
      ignore: '',
      rules: {
        firstname: { required: true, minlength: 2, maxlength: 40 },
        lastname: { required: true, minlength: 2, maxlength: 40 },
        phone: { required: true, tc_phoneUS: true },
        email: { required: true, tc_emailDomainCheck: true },
        part_subject: { required: true, minlength: 2 },
        part_message: { required: true, minlength: 10 },
        file1: { required: true },
        file2: { required: true }
      },
      messages: {
        firstname: { required: 'Please enter your first name' },
        lastname: { required: 'Please enter your last name' },
        email: { required: 'Please enter your email address' },
        phone: { required: 'Please enter your phone number' },
        part_subject: { required: 'Please enter a subject' },
        part_message: { required: 'Please describe your part in detail' },
        file1: { required: 'Please upload the first photo of your part' },
        file2: { required: 'Please upload the second photo of your part' }
      },
      errorPlacement: function (error, element) {
        error.addClass('error');
        if (element.attr('type') === 'file') {
          var n = element.attr('id').replace('file', '');
          var fileNameDiv = document.getElementById('file-name-' + n);
          if (fileNameDiv) error.insertAfter(fileNameDiv);
          else error.insertAfter(element.closest('.phk-pi__upload'));
        } else {
          error.insertAfter(element);
        }
      },
      focusInvalid: false,
      submitHandler: function (formEl) {
        var submitBtn = $j('#submitter');
        if (submitBtn.prop('disabled')) return false;
        renameUploadedFiles();
        updateIncomingMessage();
        var messageField = document.getElementById('incomingmessage');
        if (messageField && !messageField.value.trim()) {
          var pm = document.getElementById('part_message');
          messageField.value = (pm && pm.value) || 'Part identification request submitted';
        }
        submitBtn.text('Submitting…').prop('disabled', true).addClass('is-loading');
        setTimeout(function () {
          piRecaptchaThenSubmitNative(formEl, submitBtn);
        }, 100);
        return false;
      }
    });
  }

  function boot() {
    initPhotoAreas();
    if (typeof window.jQuery === 'function') {
      if (window.jQuery.fn && window.jQuery.fn.validate) initializeForm();
      else {
        // wait briefly for validate script
        var tries = 0;
        var t = setInterval(function () {
          tries++;
          if (window.jQuery && window.jQuery.fn && window.jQuery.fn.validate) {
            clearInterval(t);
            initializeForm();
          } else if (tries > 40) {
            clearInterval(t);
            initializeForm();
          }
        }, 100);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
